import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TldrCommentPanel from "../comment/TldrCommentPanel";
import TldrKeyboardShortcutsList from "../common/TldrKeyboardShortcutsList";
import TldrStudioAiPanel from "../common/TldrStudioAiPanel";
import StudioAnimationSidebar from "./advanced/animations/StudioAnimationSidebar";
import StudioBaseRightSideBar from "./advanced/common/StudioBaseRightSideBar";
import StudioAdvancedSidebar from "./advanced/StudioAdvancedSidebar";
import {
  ADVANCED_AI_EDITOR_PANEL,
  ADVANCED_ANIMATION_PANEL,
  ADVANCED_COMMENTS_PANEL,
  ADVANCED_EDITOR_PANEL,
  KEYBOARD_SHORTCUTS_PANEL,
  ADVANCED_DOWNLOAD_QUEUE_PANEL,
} from "./constants";
import { wsAddLayer } from "../../_actions/webSocketAction";
import { defaultSubHeadingTextItem } from "../canvas/constants/defaults";
import StudioDownloadQueueSidebar from './advanced/StudioDownloadQueueSidebar';

export const StudioRightSidePanel = (props) => {
  const { isActionPanelOpen, sliderPanelType } = props.rightsidebar;

  function handleAddText(result) {
    const activePageId = props.activePage?.id;
    let payload = {
      ...defaultSubHeadingTextItem,
      payload: {
        ...defaultSubHeadingTextItem.payload,
        text: result.payload.headline,
      },
    };
    props.wsAddLayer(activePageId, payload);
  }

  return (
    <>
      {isActionPanelOpen && (
        <StudioBaseRightSideBar
          title={sliderPanelType}
          canvasRef={props.canvasRef}
        >
          {sliderPanelType === ADVANCED_ANIMATION_PANEL ? (
            <StudioAnimationSidebar canvasRef={props.canvasRef} />
          ) : sliderPanelType === ADVANCED_COMMENTS_PANEL ? (
            <TldrCommentPanel/>
          ) : sliderPanelType === ADVANCED_EDITOR_PANEL ? (
            <StudioAdvancedSidebar
              artBoardHandler={props.artBoardHandler}
              canvasRef={props.canvasRef}
            />
          ) : sliderPanelType === KEYBOARD_SHORTCUTS_PANEL ? (
            <TldrKeyboardShortcutsList/>
          ) : sliderPanelType === ADVANCED_AI_EDITOR_PANEL ? (
            <TldrStudioAiPanel
              onAddText={handleAddText}
              renderlocation="editor"
            />
          ) : sliderPanelType === ADVANCED_DOWNLOAD_QUEUE_PANEL ? (
            <StudioDownloadQueueSidebar/>
          ) : (
            <></>
          )}
        </StudioBaseRightSideBar>
      )}
    </>
  );
};

StudioRightSidePanel.propTypes = {
  rightsidebar: PropTypes.object.isRequired,
  canvasRef: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  rightsidebar: state.rightsidebar,
  activePage: state.pagestore.pages[state.editor.activePage?.id],
});

const mapDispatchToProps = (dispatch) => ({
  wsAddLayer: (pageId, message) => dispatch(wsAddLayer(pageId, message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudioRightSidePanel);
